import { FormGroupBulletList } from '@frontend/components/pages/episodeCategory/customControls/hearingLoss/hearingLossComponents/FormGroupBulletList';

export function HearingLossAssessmentBijgevoegdeInformatie() {
    return (
        <FormGroupBulletList
            items={['Beoordeling audiologisch onderzoek', 'Audiologisch onderzoek']}
            label="Bijgevoegde informatie"
        />
    );
}
